import { useEffect, useState } from "react";
import { Step } from "./Onestop";
import { Button, Icon, Dimmer, Message, Modal, ModalContent } from "semantic-ui-react";
import { getStorage, updateStorage } from "./Onestop";
import { fetchWithAuth, getCSRFToken } from "../auth";
import { LoadingWrapper } from "../common";
import { PreviousReadinessModal } from "./PreviousReadinessModal";
import { Link } from "react-router-dom";
import './Onestop.css'

export const ReadinessStep = props => {
    const storage = getStorage()
    const [readinessNeedsUpdate, setReadinessNeedsUpdate] = useState(storage && storage.readinessNeedsUpdate)
    const [isRepeatReadiness, setIsRepeatReadiness] = useState(storage && storage.isRepeatReadiness)
    const [updatedReadiness, setUpdatedReadiness] = useState(storage && storage.updatedReadiness)
    const [previousReadiness, setPreviousReadiness] = useState({})
    const [loaded, setLoaded] = useState(true)
    const [dimming, setDimming] = useState(false)
    const [fetchError, setFetchError] = useState(false)
    const [modalOpen, setModalOpen] = useState(false)

    async function repeatReadiness() {
        setLoaded(false)
        setReadinessNeedsUpdate(false)
        setIsRepeatReadiness(true)
        updateStorage('readinessNeedsUpdate', false)
        updateStorage('isRepeatReadiness', true)
        const response = await fetch(process.env.REACT_APP_ICC_TOOL_API_HOST + `readiness/repeat/`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'X-CSRFToken': getCSRFToken()
            },
            credentials: 'include',
            body: JSON.stringify({
                id: props.team.id
            })
        });
        if(!response.ok) {
            setFetchError(true)
            needsToUpdateReadiness()
        } else {
            const wasAlreadyFinished = updatedReadiness || isRepeatReadiness
            if(!wasAlreadyFinished) {
                setDimming(true)
            }
            setTimeout(() => {
                props.nextStep()
                setDimming(false)
            }, wasAlreadyFinished ? 0 : 750)
        }
        setLoaded(true)
    }

    async function getPreviousReadiness() {
        const resp = await fetchWithAuth(process.env.REACT_APP_ICC_TOOL_API_HOST + `readiness?team=${props.team.id}&count=1`, {
            headers: {
                'X-CSRFToken': getCSRFToken()
            }
        })
        const respJson = await resp.json()
        setPreviousReadiness(respJson)
    }

    useEffect(() => {
        if(props.team.id) {
            getPreviousReadiness()
        }
    }, [props.team.id])

    function needsToUpdateReadiness() {
        updateStorage('readinessNeedsUpdate', true)
        updateStorage('isRepeatReadiness', false)
        setReadinessNeedsUpdate(true)
        setIsRepeatReadiness(false)
        if (props.team.id) {
            sessionStorage.setItem('readinessTeam', props.team.id)
        }
    }

    function didUpdateReadiness() {
        updateStorage('updatedReadiness', true)
        const wasAlreadyFinished = updatedReadiness || isRepeatReadiness
        if(!wasAlreadyFinished) {
            setDimming(true)
        }
        setUpdatedReadiness(true)
        setTimeout(() => {
            props.nextStep()
            setDimming(false)
        }, wasAlreadyFinished ? 0 : 750)
    }

    useEffect(() => {
        const storage = getStorage()
        if (storage) {
            if (storage['readinessNeedsUpdate']) {
                needsToUpdateReadiness()
            } else if (storage['isRepeatReadiness']) {
                setIsRepeatReadiness(true)
            }
            if (storage['updatedReadiness']) {
                setUpdatedReadiness(true)
            }
        }
    }, [])

    return <LoadingWrapper loading={!loaded}>
        <Modal open={modalOpen} size={"small"}>
            <ModalContent align="center">
                <PreviousReadinessModal members={previousReadiness.members}
                                        team={previousReadiness.team}
                                        assets={previousReadiness.assets} />
                <Button style={{margin: "1rem"}} onClick={() => setModalOpen(false)}>Close</Button>
            </ModalContent>
        </Modal>
        {fetchError && <Message negative>Something went wrong. Please fill out the report manually.</Message>}
        <Step completed={updatedReadiness || isRepeatReadiness}>
            <div className='onestop-header'>Has your readiness changed from your last report? <Link onClick={() => setModalOpen(true)}>{previousReadiness.team ? "(View)" : ""}</Link></div>
            <div className='onestop-content'>Includes sick team members who are back, assets which work now or are broken, etc</div>
            <div>
                <Button style={{ backgroundColor: readinessNeedsUpdate ? "lightgreen" : "" }} onClick={needsToUpdateReadiness}>Yes</Button>
                <Button style={{ backgroundColor: isRepeatReadiness ? "lightgreen" : "" }} onClick={repeatReadiness}>No</Button>
            </div>
            {(readinessNeedsUpdate || fetchError) && <>
                <div className="divider-bottom"></div>
                <div className='onestop-content'>Please fill out the following form and then return to this page. </div>
                <Link to={'/readiness'}>{props.team.name} Readiness</Link>
                <div className="divider-bottom" />
                <Button onClick={didUpdateReadiness} style={{ backgroundColor: updatedReadiness ? "lightgreen" : "", margin: "1rem" }}>Done</Button>
            </>
            }
            <Dimmer active={dimming} inverted>
                <Icon className="check" color="green" size="huge" />
            </Dimmer>
        </Step>
    </LoadingWrapper>
}